import React from 'react';
import classnames from 'classnames';
import {capitalize} from 'lodash';
import PropTypes from 'prop-types';
import Checkbox from 'generic/Forms/Checkbox/Checkbox.react';
import SupplementManagerModalButton from 'client/Supplements/SupplementManager/SupplementManagerModalButton.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';
import AuthoringTextInput from 'client/EditPage/V2/AuthoringTextInput/AuthoringTextInput.react';

export default class TwoWayRowColumn extends React.Component {
  static propTypes = {
    rowIndex: PropTypes.number,
    side: PropTypes.string,
    column: PropTypes.object,
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onBlur: PropTypes.func,
    onModelChange: PropTypes.func
  };

  onColumnTextChange = (e) => {
    const column = this.props.column.set('text', e.target.value);
    const rows = this.props.question
      .getRows()
      .setIn([this.props.rowIndex, 'columns', this.props.side], column);

    const updatedQuestion = this.props.question.setRows(rows);
    this.props.onModelChange(updatedQuestion);
  };

  setColumnCorrect = (e) => {
    let validResponse = this.props.question.getValidResponse();
    if (e.target.checked) {
      validResponse = validResponse.set(this.props.column.get('id'), true);
    } else {
      validResponse = validResponse.remove(this.props.column.get('id'));
    }

    const updatedQuestion = this.props.question.setValidResponse(validResponse);
    this.props.onModelChange(updatedQuestion, 'rubric');
  };

  generateColumnHeader() {
    if (this.props.rowIndex !== 0) {
      return null;
    }

    const columnNumber = this.props.side === 'left' ? 1 : 2;
    return (
      <div className='a-form-input__label two-way-editor__column-header'>Column {columnNumber}</div>
    );
  }

  render() {
    const side = this.props.side;
    const capitalizedSide = capitalize(side);
    const rowIndex = this.props.rowIndex;
    const isChecked = this.props.question.getValidResponse().has(this.props.column.get('id'));
    const columnClasses = classnames(
      `two-way-editor__row-input two-way-editor__row-input--${side}`,
      {
        'is-correct-choice': isChecked
      }
    );
    const fieldPath = `rows,${this.props.rowIndex},columns,${side},text`;
    return (
      <div className='two-way-editor__column'>
        {this.generateColumnHeader()}
        <div className={`two-way-editor__row two-way-editor__row--${side}`}>
          <Checkbox
            className={`two-way-editor__row-checkbox two-way-editor__row-checkbox--${side}`}
            checked={isChecked}
            onChange={this.setColumnCorrect}
          />
          <AuthoringTextInput
            displayAs='input'
            className={columnClasses}
            value={this.props.column.get('text')}
            onChange={this.onColumnTextChange}
            onBlur={this.props.onBlur}
            data-field-path={fieldPath}
            name={`row${capitalizedSide}`}
          />
          <SupplementManagerModalButton
            className={`two-way-editor__add-supplement-btn two-way-editor__row-add-supplement-btn two-way-editor__row-add-supplement-btn--${side}`}
            color='blue'
            linkButton
            pathToProperty={fieldPath}
          />
        </div>
      </div>
    );
  }
}
